export default {
  errNoPortfoliosContent: 'This account does not have access to any portfolios. Please contact your administrator to configure portfolio permissions.',
  errNoPortfoliosHeader: 'No Portfolio Available',
}
